module.exports = __webpack_public_path__ + "static/media/Line.f02b98ca.jpg";